import { BaseComponent } from '../../base/base.component';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoData } from '../../../shared/public-api';

@Component({
  selector: 'admin-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  imports: [CommonModule],
})
export class InfoComponent extends BaseComponent<InfoData> implements OnInit {
  title = '';
  text = '';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.title = this.data.title;
    this.text = this.data.text;
  }
}
